<template>
  <div class="mydevice-bd">
    <div class="product-wrap">
      <div class="search-hd">
        <el-form :inline="true" @submit.native.prevent>
          <!-- 配置项 -->
          <!-- <el-form-item>
            <el-button type="primary" v-if="funcView.func_unbind" :disabled="!selectedData.length" @click="onDeleteRows()" >{{funcView.func_unbind}}</el-button>
          </el-form-item> -->
          <el-form-item style="float: right; margin-right: 0">
            <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
          </el-form-item>
          <!-- 搜索项 -->
          <el-form-item style="float: right;">
            <el-input
              :placeholder="$t('crm_rent-device.xiang_mu')"
              v-model="formSearch.locationName"
              clearable
              @keyup.enter.native="onPageChange({ page: 1 })"
              style="width: 280px;"
            >
              <template slot="append">
                <div @click="onPageChange({ page: 1 })">
                  <i class="icon icon-search"></i>
                </div>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item style="float: right;">
            <el-input
              :placeholder="$t('crm_rent-device.ji_shen_hao')"
              v-model="formSearch.search"
              clearable
              @keyup.enter.native="onPageChange({ page: 1 })"
              style="width: 280px;"
            >
              <template slot="append">
                <div @click="onPageChange({ page: 1 })">
                  <i class="icon icon-search"></i>
                </div>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item style="float: right">
            <el-input
              :placeholder="$t('crm_rent-device.zu_lin_fang')"
              v-model="formSearch.orgName"
              clearable
              @keyup.enter.native="onPageChange({ page: 1 })"
              style="width: 280px;"
            >
              <template slot="append">
                <div @click="onPageChange({ page: 1 })">
                  <i class="icon icon-search"></i>
                </div>
              </template>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-bd">
          <custom-table
            v-if="funcView.func_check_device_list"
            ref="tb1"
            v-loading="isLoading"
            border
            :size="allTableSize"
            :column="tableColumn"
            :data="deviceList"
            selectableKey="selectableKey"
            height="100%"
            @selection-change="selectionChange"
            @sort-change="sortChange"
            @filter-change="filterChange"
            :slots="['action']"
          >
          <!-- <template slot="action" slot-scope="scope">
             <el-button type="text" size="mini" v-if="funcView.func_unbind&&!scope.row.selectableKey" @click="onDeleteBtn(scope.row)" >{{funcView.func_unbind}}</el-button>
          </template> -->
          </custom-table>
      </div>
      <div class="table-page">
         <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
      </div>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  props: {
    roleData: {
      type: Object,
      default() {
        return {};
      }
    },
  },
  data() {
    return {
      tableCode: 'rent_device',

      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        bizId: '',
        bizType: 1,
        isAss: 1,
        orgType: 'CS',
        orgName: '',
        locationName: '',
      },

      deviceList: [],
      totalRows: null
    };
  },
  watch: {
    roleData: function () {
      // console.log(this.roleData.partnerOrgId);
      // this.formSearch.orgId = this.roleData.partnerOrgId;
      this.getDeviceList();
    }
  },
  mounted() {
    // this.formSearch.orgId = this.roleData.partnerOrgId;
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getTableColumn();
    this.getFuncView();
    this.getDeviceList();
  },
  methods: {

    // 获取我的设备列表
    getDeviceList: function () {
      this.formSearch.bizId = this.roleData.partnerOrgId;
      if (this.formSearch.bizId) {
        this.isLoading = true;
        this.$getJSON(apis.BizDevicePage, this.formSearch).then((res) => {
          if (res.code === 0) {
            this.isLoading = false;
            const list = res.data.list || [];
            list.forEach((item) => {
              item.selectableKey = `${item.isAuto}` === '1';
            });
            this.deviceList = list;
            this.totalRows = res.data.total || null;
          }
        });
      } else {
        this.isLoading = false;
        this.deviceList = [];
        this.totalRows = null;
      }

    },


    // 切换页
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getDeviceList();
    },
    // 删除单个
    onDeleteBtn(row) {
      const tips = this.$t('crm_rent-device.nqdyscdqxzdsbm');
      const deviceIds = [row.deviceId];
      const param = {
        bizId: this.formSearch.bizId,
        deviceIds
      };
      this.$showConfirm(tips).then(() => {
        this.$postJSON(apis.BizDeviceUnbind, param).then(() => {
          this.$message({
            message: this.$t('Common.com_delete_success'),
            type: 'success'
          });
          this.getDeviceList();
        });
      })
        .catch(() => { });
    },

  }
};
</script>

<style lang="scss">
.mydevice-bd {
  height: 100%;
  display: flex;
  flex-direction: column;
  .product-info {
    position: relative;
    background-color: #ffffff;
    height: 220px;
    display: flex;
    .g2-p1 {
      width: 500px;
      height: 220px;
    }
    .g2-p2 {
      width: 460px;
      height: 200px;
      .g2-legend {
        height: 120px !important;
        width: 800px !important;
        max-width: 800px !important;
      }
      .g2-legend-list {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        height: 100%;
      }
      .g2-legend-list-item {
        width: 120px;
      }
    }
  }
  .product-wrap {
    flex: 1;
    height: 0;
    display: flex;
    flex-direction: column;
    padding: 0 10px;
    margin: 10px;
    background-color: #ffffff;
  }
  .card-bd {
    flex: 1;
    height: 0;
    overflow-y: auto;
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        width: 218px;
        height: 247px;
        border-radius: 2px;
        border: 1px solid rgba(233, 233, 233, 1);
        margin-right: 12px;
        margin-bottom: 10px;
        text-align: center;
        position: relative;
        padding: 10px;
        .btn-del {
          position: absolute;
          color: #666666;
          font-size: 15px;
          left: 10px;
          top: 8px;
          cursor: pointer;
        }
        .btn-edit {
          position: absolute;
          color: #666666;
          font-size: 15px;
          left: 35px;
          top: 8px;
          cursor: pointer;
        }
        .status {
          position: absolute;
          right: 0;
          top: 0;
          line-height: 28px;
          color: #ffffff;
          width: 50px;
          font-size: 12px;
          background-color: #00afff;
          border-bottom-left-radius: 24px;
          text-align: right;
          padding-right: 8px;
        }
        .img-box {
          font-size: 0;
          height: 180px;
          img {
            display: inline-block;
            width: 160px;
            height: 160px;
          }
        }
        h1 {
          color: #00afff;
          font-size: 18px;
          font-weight: bold;
          line-height: 25px;
        }
        p {
          margin-top: 5px;
          font-size: 12px;
          line-height: 17px;
        }
      }
    }
  }
}
</style>
